<template>
  <v-container :fluid="$vuetify.breakpoint.mdAndDown">
    <v-row>
      <v-col cols="12">
        <h2 class="text-h4 font-weight-black" v-if="selectedTab === 'domestic'">
          Contributions to life expectancy gains in Hong Kong
        </h2>
        <h2
          class="text-h4 font-weight-black"
          v-if="selectedTab === 'international'"
        >
          Contributions to life expectancy gap
        </h2>
      </v-col>
      <v-col cols="12" sm="9">
        <v-tabs v-model="selectedTab" centered>
          <v-tab key="domestic" href="#domestic">Domestic comparison</v-tab>
          <v-tab key="international" href="#international"
            >International comparison</v-tab
          >
          <v-tabs-slider></v-tabs-slider>
          <v-tab-item value="domestic">
            <v-row class="chart-container">
              <h3 v-if="selectedYears && selectedGender" class="text-center">
                Contributions to life expectancy gains by age, sex, and
                underlying cause of death
              </h3>
              <!-- <h3 v-if="selectedYears && selectedGender" class="text-center">
            Contributions to life expectancy gains by age,
            {{ selectedGender }}, and underlying cause of death:
            {{ selectedYears }}
          </h3> -->
              <v-chart
                autoresize
                v-if="selectedGender && selectedYears"
                :options="chartOptions[`${selectedYears}${selectedGender}`]"
              ></v-chart>
            </v-row>
          </v-tab-item>
          <v-tab-item value="international">
            <h3 v-if="selectedGender" class="text-center">
              Contributions to the difference in life expectancy between Hong
              Kong and high-income countries, 2016
            </h3>
            <v-img v-if="selectedGender" :src="international[selectedGender]">
            </v-img>
            <p v-if="selectedGender">
              Note: Blue corresponds to the survival advantage in Hong Kong,
              while red corresponds to the survival advantage in high-income
              countries. The yellow signifies no survival advantage to either
              Hong Kong or high-income countries. This cause decomposition
              comparison was analyzed over ICD-9 and ICD-10 codes.
            </p>
          </v-tab-item>
        </v-tabs>
      </v-col>
      <v-col cols="12" sm="3">
        <v-card>
          <v-card-text>
            <!-- <p>
              Instructions: Please select the sex (e.g. male) and period range
              (e.g. 1979-2018) of interest. Hover over the bars to show exact
              figure breakdown.
            </p> -->
            <template v-if="selectedTab === 'domestic'">
              <p>
                Select the sex and time period of interest. Hover over the bars
                to show the corresponding life expectancy gains.
              </p>
              <v-select
                rounded
                outlined
                v-model="selectedYears"
                :items="years"
                label="Select years"
              ></v-select>
            </template>
            <v-radio-group v-model="selectedGender" label="Select sex">
              <v-radio
                v-for="gender in genders"
                :key="gender.value"
                :value="gender.value"
                :label="gender.text"
              ></v-radio>
            </v-radio-group>
            <!-- <p>
              Example 1: For females, cardiovascular diseases contributed to
              +0.78 in life expectancy gains in the age group 75-79, from 1979
              to 2018. In other words, there has been an improvement in life
              expectancy in older females (75-79 years old) due to fewer
              cardiovascular disease-related deaths in that age group.
            </p>
            <p>
              Example 2: For males, cancer contributed to -0.028 in life
              expectancy gains in the age group 70-74 from 1979-1988. In other
              words, there has been an deprovement in life expectancy in older
              males (70-74 years old) due to more cancer-related deaths in that
              age group.
            </p> -->
            <p v-if="selectedTab === 'domestic'">
              Causes of death can be removed from the figure by clicking on the
              category in the legend
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- <migrants id="migrants"></migrants> -->
  </v-container>
</template>
<script>
// import Arriaga from "./Arriaga";
// import Migrants from "./Migrants";

import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/component/legendScroll";
import "echarts/lib/component/legend";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/dataZoom";
import "echarts/lib/component/axis";
import chartOptions from "../data/charts.json";
import genders from "../data/genders.js";
import international from "../data/international.js";
export default {
  name: "LifeExpectancy",
  components: { "v-chart": ECharts },
  data: () => ({
    selectedYears: null,
    selectedGender: null,
    genders,
    selectedTab: null,
    international,
    years: [
      {
        text: "1979 - 2019",
        value: "1979-2019",
      },
      {
        text: "1979 - 1988",
        value: "1979-1988",
      },
      {
        text: "1989 - 1998",
        value: "1989-1998",
      },
      {
        text: "1999 - 2008",
        value: "1999-2008",
      },
      {
        text: "2009 - 2019",
        value: "2009-2019",
      },
    ],
    chartOptions,
  }),
  created() {
    for (const key in this.chartOptions) {
      this.chartOptions[key].tooltip.formatter = (params) => {
        const data = params.data;

        return data > 0
          ? `${params.marker} For age group <strong>${
              params.name
            }</strong> of ${params.seriesName}<br />gain ${data.toPrecision(
              2
            )} year`
          : `${params.marker} For age group <strong>${
              params.name
            }</strong> of ${params.seriesName}<br />loss ${(-data).toPrecision(
              2
            )} year`;
      };
    }
  },
};
</script>
<style scoped>
.chart-container >>> .echarts {
  width: 100%;
  height: 600px; /* or e.g. 400px */
}
</style>